var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit, OnChanges, } from '@angular/core';
import { Store } from '@ngxs/store';
import { DownloadEntries } from '../../state/actions/commands';
import { BehaviorSubject } from 'rxjs';
import { FilePreviewOverlayComponent } from '../file-preview-overlay/file-preview-overlay.component';
import { OverlayPanel } from '../../../../common/core/ui/overlay-panel/overlay-panel.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ShareableLinksApiService } from '../../sharing/links/shareable-links-api.service';
import { InfiniteScroll } from '../../../../common/core/ui/infinite-scroll/infinite.scroll';
import { finalize } from 'rxjs/operators';
var FolderPreviewComponent = /** @class */ (function (_super) {
    __extends(FolderPreviewComponent, _super);
    function FolderPreviewComponent(store, overlay, router, linkApi) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.overlay = overlay;
        _this.router = router;
        _this.linkApi = linkApi;
        _this.loading$ = new BehaviorSubject(false);
        _this.viewMode$ = new BehaviorSubject('grid');
        _this.breadcrumb$ = new BehaviorSubject([]);
        _this.pagination$ = new BehaviorSubject(null);
        _this.allFolders = {};
        _this.sortFormControl = new FormControl({
            column: 'updated_at',
            direction: 'desc',
        });
        return _this;
    }
    Object.defineProperty(FolderPreviewComponent.prototype, "folder", {
        get: function () {
            return this.data.link.entry;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FolderPreviewComponent.prototype, "children", {
        get: function () {
            return this.pagination$.value.data;
        },
        enumerable: true,
        configurable: true
    });
    FolderPreviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.sortFormControl.valueChanges.subscribe(function (value) {
            if (value) {
                _this.loadChildren({}, true);
            }
        });
    };
    FolderPreviewComponent.prototype.ngOnChanges = function () {
        this.allFolders[this.folder.id] = this.folder;
        this.generateBreadcrumb(this.folder);
        this.setPagination(this.data.folderChildren);
        this.loading$.next(false);
    };
    FolderPreviewComponent.prototype.download = function () {
        this.store.dispatch(new DownloadEntries([this.folder], this.data.link, this.password));
    };
    FolderPreviewComponent.prototype.toggleViewMode = function () {
        this.viewMode$.next(this.viewMode$.value === 'grid' ? 'list' : 'grid');
    };
    FolderPreviewComponent.prototype.openPreviewOverlay = function (entry) {
        var entries = this.children.filter(function (ent) { return ent.type !== 'folder'; }), activeEntry = entries.findIndex(function (e) { return e.id === entry.id; });
        this.overlay.open(FilePreviewOverlayComponent, {
            position: 'center',
            origin: 'global',
            panelClass: 'file-preview-overlay-container',
            data: {
                entries: entries,
                activeEntry: activeEntry,
                hideMoreOptionsBtn: true,
            }
        });
    };
    FolderPreviewComponent.prototype.getEntry = function (e) {
        var node = e.target.closest('.drive-entry');
        if (node) {
            return this.children.find(function (entry) { return entry.id === +node.dataset.id; });
        }
    };
    FolderPreviewComponent.prototype.onTap = function (e) {
        var entry = this.getEntry(e);
        if (!entry)
            return;
        if (entry.type === 'folder') {
            this.openFolder(entry);
        }
        else {
            this.openPreviewOverlay(entry);
        }
    };
    FolderPreviewComponent.prototype.isSubFolder = function () {
        return this.router.url.indexOf(':') > -1;
    };
    FolderPreviewComponent.prototype.openFolder = function (folder) {
        var _this = this;
        if (folder && this.folder.id === folder.id)
            return;
        this.loading$.next(true);
        this.router.navigate(['/drive/s', this.makeLinkHash(folder)]).then(function () {
            // reset sort to default, as there's no good way to
            // pass current sort to parent link preview component
            _this.sortFormControl.reset();
        });
    };
    FolderPreviewComponent.prototype.generateBreadcrumb = function (folder) {
        var _this = this;
        this.breadcrumb$.next(folder.path.split('/').map(function (folderId) {
            return _this.allFolders[+folderId];
        }).filter(function (subFolder) { return !!subFolder; }));
    };
    FolderPreviewComponent.prototype.loadChildren = function (params, replaceChildren) {
        var _this = this;
        if (replaceChildren === void 0) { replaceChildren = false; }
        this.loading$.next(true);
        var order = this.sortFormControl.value.column + ":" + this.sortFormControl.value.direction;
        var page = params.page || this.pagination$.value.current_page;
        this.linkApi.findByHash(this.makeLinkHash(this.folder), { page: page, order: order, withEntries: true })
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function (response) {
            var oldChildren = _this.children;
            var pagination = response.folderChildren;
            if (!replaceChildren) {
                pagination.data = oldChildren.concat(_this.data.folderChildren.data);
            }
            _this.setPagination(pagination);
        });
    };
    FolderPreviewComponent.prototype.makeLinkHash = function (folder) {
        var hash = this.data.link.hash;
        if (folder)
            hash += ':' + folder.hash;
        return hash;
    };
    FolderPreviewComponent.prototype.setPagination = function (pagination) {
        var _this = this;
        // add shareable link hash to all entries url to avoid permission errors
        pagination.data = pagination.data.map(function (entry) {
            entry.url += "?shareable_link=" + _this.data.link.id;
            if (_this.password) {
                entry.url += "&password=" + _this.password;
            }
            return entry;
        });
        this.pagination$.next(pagination);
    };
    FolderPreviewComponent.prototype.loadMoreItems = function () {
        var page = this.pagination$.value.current_page + 1;
        this.loadChildren({ page: page }, false);
    };
    FolderPreviewComponent.prototype.canLoadMore = function () {
        return this.pagination$.value.current_page < this.pagination$.value.last_page;
    };
    FolderPreviewComponent.prototype.isLoading = function () {
        return this.loading$.value;
    };
    return FolderPreviewComponent;
}(InfiniteScroll));
export { FolderPreviewComponent };
